import React, { useEffect, useState, useRef } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { SlLocationPin } from "react-icons/sl";
import axiosConfig from "../../Service/AxiosConfig";
import "./UserProfile.css";
import { useSelector } from "react-redux";
import { FaChevronDown } from "react-icons/fa";
import { PopupModal } from "../../PopupModal/PopupModal";
import { AddressModal } from "../../Modal/AddressModal";
const AddressGrid = ({ form, setForm, fetchBooking }) => {
  const [saving, setSaving] = useState(false);
  const hasFetchedRef = useRef(false);
  const [expanded, setExpanded] = useState(false);
  const [currentAddressError, setCurrentAddressError] = useState("");
  const [permanentAddressError, setPermanentAddressError] = useState("");
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const [isSaved, setIsSaved] = useState(false);
  const [error, setError] = useState("");
  const tempData = useSelector((state) => state.bookingForm.tempData);
  const firstFieldRef = useRef(null);
  const hasFocusedOnce = useRef(false);
  const fieldsToCheck = ["current_address", "permanent_address"];
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const hasAnyData = fieldsToCheck.some((key) => {
    const value = form?.[key];
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "boolean") return value === true;
    return value && String(value).trim() !== "";
  });
  useEffect(() => {
    if (!form?.id) return;

    if (!hasFetchedRef.current) {
      const backendHasData =
        form.permanent_address_id || form.current_address_id;

      setIsSaved(!!backendHasData);

      hasFetchedRef.current = true;
    }
  }, [form?.id]);

  useEffect(() => {
    if (!expanded) return;
    const isApiDataEmpty = fieldsToCheck.every(
      (key) => !form?.[key] || String(form[key]).trim() === "",
    );
    if ((isApiDataEmpty || !hasFocusedOnce.current) && firstFieldRef.current) {
      setTimeout(() => {
        firstFieldRef.current.focus();
        hasFocusedOnce.current = true;
      }, 0);
    }
  }, [expanded, form]);

  useEffect(() => {
    const id = form?.id;
    if (!id || hasFetchedRef.current) return;
    hasFetchedRef.current = true;
  }, [form?.id]);

  if (!form) return null;

  const handleSaveAdress = async () => {
    if (saving) return;
    if (!form?.id) return;

    setSaving(true);
    setError("");

    const payload = {
      current_address: form.current_address_id || null,
      permanent_address: form.permanent_address_id || null,
    };
    try {
      await axiosConfig.patch(`/provider-data/providers/${form.id}/`, payload);
      setPopupType("success");
      setMessage("Address Details Saved Successfully");

      setIsSaved(true);
      setExpanded(false);
      fetchBooking();
    } catch (err) {
      setPopupType("error");
      setError(err?.response?.data?.detail || "Failed to save details");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Accordion
        key={expanded ? "open" : "closed"}
        allowZeroExpanded
        preExpanded={expanded ? ["patient"] : []}
        onChange={(uuids) => {
          setExpanded(uuids.includes("patient"));
        }}
      >
        <AccordionItem uuid="patient">
          <AccordionItemHeading>
            <AccordionItemButton className="bd-header">
              <h4 className="bd-title">Address Details</h4>
              <span className="bd-add-btn">
                Add Details
                <FaChevronDown
                  style={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                    marginLeft: "5px",
                  }}
                />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="bd-panel">
            <div className="bd-section-grid bd-grid-3 service-cards">
              <div className="form-group full-width">
                <label
                  className={`form-label ${isSaved ? "view-mode-label" : ""}`}
                >
                  Permanent Address
                </label>
                <div className="bd-address-container">
                  <input
                    className={`${isSaved ? "view-mode-label" : ""}`}
                    value={form.permanent_address || ""}
                    placeholder="Enter Permanent Address"
                    style={{ padding: "10px" }}
                    readOnly
                    onFocus={() => {
                      if (!form.permanent_address) {
                        setPermanentAddressError(
                          "Please choose Permanent Address using map",
                        );
                      }
                    }}
                    onKeyDown={(e) => {
                      e.preventDefault();
                      if (!form.permanent_address_id) {
                        setPermanentAddressError(
                          "Please choose Permanent Address using map",
                        );
                      }
                    }}
                  />

                  <button
                    className="bd-choose-map-btn"
                    disabled={isSaved}
                    onClick={() => {
                      setModalMode("permanent");
                      setAddressModalOpen(true);
                    }}
                  >
                    <SlLocationPin size={16} /> Choose Map
                  </button>
                </div>
                {permanentAddressError && (
                  <p className="error-text">{permanentAddressError}</p>
                )}
              </div>
              <div className="form-group full-width">
                <label
                  className={`form-label ${isSaved ? "view-mode-label" : ""}`}
                >
                  Current Address(Optional)
                </label>
                <div className="bd-address-container">
                  <input
                    className={`${isSaved ? "view-mode-label" : ""}`}
                    value={form.current_address || ""}
                    placeholder="Enter Current Address"
                    style={{ padding: "10px" }}
                    readOnly
                    onFocus={() => {
                      if (!form.current_address) {
                        setCurrentAddressError(
                          "Please choose Current Address using map",
                        );
                      }
                    }}
                    onKeyDown={(e) => {
                      e.preventDefault();
                      if (!form.current_address_id) {
                        setCurrentAddressError(
                          "Please choose Current Address using map",
                        );
                      }
                    }}
                  />

                  <button
                    className="bd-choose-map-btn"
                    disabled={isSaved}
                    onClick={() => {
                      setModalMode("current");
                      setAddressModalOpen(true);
                    }}
                  >
                    <SlLocationPin size={16} /> Choose Map
                  </button>
                </div>
                {currentAddressError && (
                  <p className="error-text">{currentAddressError}</p>
                )}
              </div>

              <div className="form-group full-width">
                <div className="bd-actions">
                  {hasAnyData && !isSaved && (
                    <button
                      className="bd-save-btn"
                      onClick={handleSaveAdress}
                      disabled={saving}
                    >
                      Save
                    </button>
                  )}

                  {isSaved && (
                    <button
                      className="bd-edit-btn"
                      onClick={() => setIsSaved(false)}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
      <AddressModal
        isOpen={addressModalOpen}
        onClose={() => setAddressModalOpen(false)}
        mode={modalMode}
        form={form}
        setForm={setForm}
      />

      {popupType && (
        <PopupModal
          setpopupType={setPopupType}
          popupType={popupType}
          error={error}
          Message={message}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export default AddressGrid;
